"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DeferDeath_OnDeathAvoidedEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_DeferDeath_OnDeathAvoidedEventHandlerScript = class Effect_DeferDeath_OnDeathAvoidedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.DeathAvoided) {
            return;
        }
        // a marker to track whether or not the subject has been saved by defer death in the past.
        container.applyDebuff({
            sequence,
            attackerId: handler.args.scriptArgs.creatorId,
            targetId: event.subject,
            effect: new __1.DeferredDeathEffectArgs(),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
        });
        container.applyBuff({
            sequence,
            creatorId: event.subject,
            targetId: event.subject,
            effect: new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Health, container.getPercentOfBaseHealth(event.subject, 20)),
            duration: Duration_1.Duration.Permanent,
        });
        const increase = container.getLevel(event.subject);
        container.applyBuffs({
            sequence,
            creatorId: handler.args.scriptArgs.creatorId,
            targetId: event.subject,
            effects: [
                {
                    effect: new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Toughness, increase),
                    duration: Duration_1.Duration.Turns(2),
                },
                {
                    effect: new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Vitality, increase),
                    duration: Duration_1.Duration.Turns(2),
                },
            ]
        });
        container.cancelEffect(sequence, handler.args.scriptArgs.parentEffectId);
    }
};
Effect_DeferDeath_OnDeathAvoidedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DeferDeath_OnDeathAvoided")
], Effect_DeferDeath_OnDeathAvoidedEventHandlerScript);
exports.Effect_DeferDeath_OnDeathAvoidedEventHandlerScript = Effect_DeferDeath_OnDeathAvoidedEventHandlerScript;
